<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

    <div class="content">
        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">{{'REQUERIMIENTOSV3.CABECERA.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <div class="horizontal-stepper-wrapper p-20">
          <!-- <div  class="" fxLayout="column" fxLayoutAlign="start stretch">
              <mat-progress-bar mode="determinate" value="{{porcentajeAvance}}"></mat-progress-bar>
              <h4 class="mt-0 mb-10 midText">{{'REQUERIMIENTOS.VALIDACION.TIMELINE.PROGRESO2' | translate}} {{porcentajeAvance}}%</h4>
          </div> -->

            <!-- HORIZONTAL STEPPER EXAMPLE -->
            <mat-horizontal-stepper class="mat-elevation-z4" [linear]="true">
             <!-- requerimientos Nuevos -->
                <mat-step [stepControl]="">

                    <form fxLayout="column">

                        <ng-template matStepLabel>{{'REQUERIMIENTOSV3.PASO1.TITULO' | translate}}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">
                          <div fxLayout="row" fxLayoutAlign="center center" >
                          <img src="./assets/images/requerimientos.png" alt="" style="width:70%;">
                          </div>
                          <p style="font-size:  40px;font-weight:bold;margin:0;">{{'REQUERIMIENTOSV3.PASO1.SUB_TITULO' | translate}}</p>
                          <p style="font-size: 40px;color:#F5A71E;font-weight:bold;margin:0;">{{'REQUERIMIENTOSV3.PASO1.SUB_TITULO2' | translate}}</p>
                          <p style="font-size: 23px;margin:0;">{{'REQUERIMIENTOSV3.PASO1.TEXTO0_PARTE_1' | translate}}</p>
                          <p style="font-size: 23px;margin:0;">{{'REQUERIMIENTOSV3.PASO1.TEXTO0_PARTE_2' | translate}}</p>

                          <div class="" fxLayout="column" fxLayoutAlign="start start">
                            <p style="font-size: 20px;color:#F5A71E;font-weight:bold;margin:20;">{{'REQUERIMIENTOSV3.PASO1.SUB_TITULO3' | translate}}</p>
                            <p style="font-size: 15px;font-weight:bold">{{'REQUERIMIENTOSV3.PASO1.SUB_TITULO4' | translate}}</p>
                          </div>
                            <table id="myTable">
                                <tr>
                                    <td style="width:40%; background-color: #f1f1f1">{{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_SISTEMAS' | translate}}</td>
                                    <td style="width:60%; background-color: #f1f1f1">• Microsoft Windows 7 {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_RECOMENDADO' | translate}}<br> • MacOS 10.10.5 <br> • Android 6.0 {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_SUPERIOR' | translate}}
                                        <br> • iOs 7.1.2 {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_SUPERIOR' | translate}}<br>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_NAVEGADOR' | translate}}</td>
                                    <td>• Google Chrome {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION' | translate}} <br> • Mozilla Firefox {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION' | translate}} <br> • Apple Safari
                                        {{'REQUERIMIENTOSV3.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION_MIN' | translate}}<br> • Microsoft Edge<br>
                                    </td>
                                </tr>

                            </table>
                            <br>
                            <p>{{'REQUERIMIENTOSV3.PASO1.TEXTO1_PARTE_1' | translate}}</p>
                            <p>{{'REQUERIMIENTOSV3.PASO1.TEXTO1_PARTE_2' | translate}}</p>

                            <p>{{'REQUERIMIENTOSV3.PASO1.TEXTO2_PARTE_1' | translate}}</p>

                          </div>
                          <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button color="primary" matStepperNext>
                          {{'REQUERIMIENTOSV3.BOTONES.SIGUIENTE' | translate}}
                          </button>
                          </div>

                          </form>
                          <div class="divfooter" fxFlex="100">
                            <img class="imgfooter" src="./assets/images/icon.png" alt="">
                          </div>



                </mat-step>



                <mat-step [stepControl]="">

                    <form fxLayout="column">

                        <ng-template matStepLabel>{{'REQUERIMIENTOSV3.PASO2.TITULO' | translate}}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">
                           <p style="font-size:  40px;margin:0px;">Whilelists de firewall: {{'REQUERIMIENTOSV3.PASO2.SUB_TITULO1' | translate}}</p>
                           <p>{{'REQUERIMIENTOSV3.PASO2.TEXTO0_PARTE_1' | translate}}</p>
                           <p>{{'REQUERIMIENTOSV3.PASO2.TEXTO1_PARTE_1' | translate}}</p>
                        <br>
                        </div>

                        <table class="egt" style="width:100%;">

                          <tr>
                            <th style="border: 1px solid black;margin:0px" colspan="2">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_ELEMENTO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_REGIONM' | translate}}</th>
                            <!-- <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_REGIONC' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_REGIONA' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_REGIONE' | translate}}</th> -->
                          </tr>

                          <tr>
                            <th style="border: 1px solid black;margin:0px" colspan="2">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DOMINIO_PRINCIPAL' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">culturalgo.com</th>
                          </tr>
                             <!-- Inicio Contenido Aplicador de Encuesta  -->
                          <tr>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                            {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_APLICADOR' | translate}}
                            </th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">newsurvey.culturalgo.com</th>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.247.154.187</th>
                          </tr>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">80 y 443</th>
                          </tr>
                          <!-- Fin Contenido Aplicador de Encuesta  -->
                          <!-- Inicio Contenido Plataforma de Administracion  -->
                          <tr>
                            <th rowspan="3"  style="border: 1px solid black;margin:0px">
                            {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PLATAFORMA' | translate}}
                            </th>

                            <th style="border: 1px solid black;margin:0px"rowspan="1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">app04.culturalgo.com</th>
                            </tr>
                          <!-- <tr>
                            <th style="border: 1px solid black;margin:0px">back04.culturalgo.com</th>
                            </tr> -->

                          <tr>
                            <th style="border: 1px solid black;margin:0px"rowspan="1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.247.131.159</th>
                          </tr>
                          <!-- <tr>
                            <th style="border: 1px solid black;margin:0px">35.197.141.96</th>
                          </tr> -->
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">443</th>
                          </tr>
                          <!-- Fin Contenido Plataforma de Administracion  -->
                          <!-- Inicio Contenido Envoltura de URL  -->
                          <tr>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                            {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_ENVOLTURA' | translate}}
                            </th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">4all.gptw.global/</th>


                          </tr>

                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.240.209.168</th>

                          </tr>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">80 y 443</th>

                          </tr>
                          <!-- Fin Contenido Envoltura de URL  -->
                          <!-- Inicio Contenido Resultados Tablou R  -->
                          <tr>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                            {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_RESULTADOS' | translate}}
                            </th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">success.culturalgo.com</th>


                          </tr>

                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.247.186.75</th>

                          </tr>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">80 y 443</th>

                          </tr>
                          <!-- Fin Contenido Resultados (Tablou R)  -->
                          <!-- Inicio Contenido Culture Audit r  -->
                          <tr>
                            <th rowspan="3" style="border: 1px solid black;margin:0px">
                              {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_CULTURE' | translate}}
                            </th>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">culture04.culturalgo.com/</th>
                            </tr>

                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">34.124.145.16</th>

                          </tr>
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">8443</th>

                          </tr>
                          <!-- Fin Contenido Culture Audit r  -->

                          <!-- Inicio Contenido Portal de conteos Externo  -->
                          <tr>
                            <th rowspan="5" colspan="1" style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PORTAL' | translate}}
                            </th>
                            <th style="border: 1px solid black;margin:0px"rowspan="1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_SUBDOMINIO' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">app04.culturalgo.com</th>
                          </tr>
                          <!-- <tr>
                            <th style="border: 1px solid black;margin:0px">back04.culturalgo.com</th>
                            </tr> -->

                          <tr>
                            <th style="border: 1px solid black;margin:0px"rowspan="1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_DIRECCION_IP' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">35.247.131.159</th>
                          </tr>
                          <!-- <tr>
                            <th style="border: 1px solid black;margin:0px">35.247.131.159</th>
                          </tr> -->
                          <tr>
                            <th style="border: 1px solid black;margin:0px">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TH_PUERTOS' | translate}}</th>
                            <th style="border: 1px solid black;margin:0px">443</th>
                          </tr>
                          <!-- Fin Contenido Portal de conteos Externo  -->

                        </table>

                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO1' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO2' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO3' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO4' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO5' | translate}}</p>
                        <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO6' | translate}}</p>

                         <h1> Whitelists de ﬁrewall: {{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO7' | translate}}</h1>
                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO8' | translate}}</p>
                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO9' | translate}}</p>
                         <table>
                             <tr>
                                 <td style="width:40%; background-color: #f1f1f1">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TABLA_CONTENT2.TD_CUENTA_CORREO' | translate}}</td>
                                 <td style="width:60%; background-color: #f1f1f1">no-reply@gptwonline.com<br>
                                 </td>
                             </tr>
                             <tr>
                                 <td>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TABLA_CONTENT2.TD_DOMINIO' | translate}}</td>
                                 <td> em7632.gptwonline.com</td>
                             </tr>

                         </table>

                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO10' | translate}}</p>
                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO11' | translate}}</p>
                         <p>{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO12' | translate}}</p>
                         <span style="font-weight: 700;">{{'REQUERIMIENTOSV3.PASO2.TABLE_CONTEN.TEXTO13' | translate}}  <span style="font-size: 17px; color:#e40601">support@itbm.mx</span></span>
                       <div fxLayout="row" fxLayoutAlign="center center">
                       <button mat-raised-button color="primary" matStepperPrevious>
                         {{'REQUERIMIENTOSV3.BOTONES.ANTERIOR' | translate}}
                       </button>
                       <button mat-raised-button color="primary" matStepperNext class="ml-20">
                         {{'REQUERIMIENTOSV3.BOTONES.SIGUIENTE' | translate}}
                       </button>
                         </div>
                    </form>

                </mat-step>

              <mat-step [stepControl]="">

                  <ng-template matStepLabel>{{'REQUERIMIENTOSV3.PASO5.TITULO' | translate}}</ng-template>

                  <div fxFlex="1 0 auto" fxLayout="column">

                    <p class="pb-32">{{'REQUERIMIENTOSV3.PASO5.SUB_TITULO' | translate}}</p>

                    <p class="pb-32">
                      {{'REQUERIMIENTOSV3.PASO5.PARRAFO1' | translate}}
                    </p>

                    <p style="font-size: 40px;color:#F5A71E;font-weight:bold;margin:0;">{{'REQUERIMIENTOSV3.PASO5.PARRAFO2' | translate}}</p>

                    <span><span style="font-size:10px;font-weight:bold">{{'REQUERIMIENTOSV3.PASO5.PARRAFO3_1' | translate}}</span>{{'REQUERIMIENTOSV3.PASO5.PARRAFO3_2' | translate}}</span>

                    <span><span style="font-size:10px;font-weight:bold">{{'REQUERIMIENTOSV3.PASO5.PARRAFO4_1' | translate}}</span>{{'REQUERIMIENTOSV3.PASO5.PARRAFO4_2' | translate}}</span>
                    <div fxLayout="column" fxLayoutAlign="center center">
                      <p style="font-size: 40px;color:#F5A71E;font-weight:bold;margin:20;"> {{'REQUERIMIENTOSV3.PASO5.PARRAFO5' | translate}}  </p>
                    </div>


                  </div>

                  <div fxLayout="row" fxLayoutAlign="center center" style="margin-top:40px">
                    <button mat-raised-button color="primary" matStepperPrevious>
                      {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
                    </button>
                  </div>

                </mat-step>

            </mat-horizontal-stepper>
            <!-- / HORIZONTAL STEPPER EXAMPLE -->

        </div>





    </div>
    <!-- / CONTENT -->

</div>
